import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {DynamicFormRenderService} from "dmidynamic-form-render";
import {MessageService} from "../../services/message.service";
import {Istanza, IstanzaDTO} from "../../models/istanza";
import {Tributo} from "../../models/tributo";
import {IstanzaService} from "../../services/istanza.service";
import {UserData} from "../../models/user-data";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {AlertService} from "../../shared/alert/alert.service";
import {IstanzaAllegato} from "../../models/integrazione";
import {FileSupportati} from "../integrazione/integrazione.component";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {format} from "date-fns";
import {WindowRefService} from "../../services/window-ref.service";
import {TributiService} from "../../services/tributi.service";
import {Toolbar} from "../../models/toolbar";
import { FormBuilder, Validators} from '@angular/forms';
import {RatingService} from "../../services/rating.service";
import {ConfigurazioneGeneraleService} from "../../services/configurazione-generale.service";
import {PreferitiService} from "../../services/preferiti.service";
import { NavbarService } from '../../services/navbar.service';

@Component({
  selector: 'jhi-nuova-istanza',
  templateUrl: './nuova-istanza.component.html',
  styleUrls: ['./nuova-istanza.component.scss']
})
export class NuovaIstanzaComponent extends SubscriptionManager implements OnInit {
  jsonForm: any;
  titolo!: string;
  tributo!: Tributo;
  userData: UserData;
  dataIstanza: Date;
  istanzaCorrente!: IstanzaDTO;
  jsonData?: any;
  bozzaSalvata: boolean;
  anteprima: boolean;
  salvaPre: boolean;
  files: Array<File | any>;
  erroreFileExist: boolean;
  width: number;
  loading: boolean;
  loadingSave: boolean;
  elencoMN: Map<string, string>;
  cdServizio?: string;
  @ViewChild('_MD_PAGAMENTO') _md_pagamento!: ElementRef;
  @ViewChild('_MD_PAGAMENTO_CLOSE') _md_pagamento_close!: ElementRef;
  @ViewChild('_MD_ALLEGATO') _md_allegato!: ElementRef;
  @ViewChild('_MD_PREFERENZE') _md_preferenze!: ElementRef;
  @ViewChild('_MD_CONFERMA') _md_conferma!: ElementRef;
  reader = new FileReader();
  listaIstanzeAllegato: Array<IstanzaAllegato>;
  curIndex: number;
  isValid: boolean;
  selectedLanguage: string = this.translateService.currentLang;
  erroreTributo = false;
  currentStep = 0;
  totalSteps = 0;
  mostraForm = true;

  ratingForm = this.fb.group({
    valutazione: [this.fb.control<number | null>(null), Validators.required],
    primaRisposta: [this.fb.control<number | null>(null)],
    secondaRisposta: [this.fb.control<number | null>(null)],
    pnServizio: this.fb.group({
      id: ['', Validators.required]
    }),
    note: [''],
  })

  constructor(private ratingService: RatingService, private navService: NavbarService, private preferitiService: PreferitiService, protected configurazioneGeneraleService: ConfigurazioneGeneraleService, private fb: FormBuilder, private windowRef: WindowRefService, private tributiService: TributiService, private dynamicFormRenderService: DynamicFormRenderService, private translateService: TranslateService, private activatedRoute: ActivatedRoute, private alertService: AlertService, private router: Router, private messageService: MessageService, private istanzaService: IstanzaService) {
    super();
    this.isValid = true;
    this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}')
    this.dataIstanza = new Date();
    this.bozzaSalvata = false;
    this.anteprima = false;
    this.salvaPre = false;
    this.files = [];
    this.erroreFileExist = false;
    this.width = window.innerWidth;
    this.listaIstanzeAllegato = [];
    this.curIndex = 0;
    this.loading = false;
    this.loadingSave = false;
    this.elencoMN = new Map(
      [
        ["JVBERi0", "application/pdf"],
        ["0M8R4KGxGuE", "application/x-zip-compressed"],
        ["UEsDBB", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
        ["/9j/4A", "image/jpeg"],
        ["iVBORw0KGgo", "image/png"]
      ]
    )
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    this.width = (event.target as Window).innerWidth;
  }

  ngOnInit(): void {
    this.subs.sink = this.navService.updateTributoSubject.subscribe({
      next: (cdTributo) => {
        this.tributo = {} as Tributo;
        this.cdServizio = <string>cdTributo;
      }
    })
    this.subs.sink = this.dynamicFormRenderService.sendJsonDataSubject.subscribe({
      next: (jsonData) => {
        this._md_conferma.nativeElement.click();
        this.jsonData = jsonData;
      }
    })
    window.onbeforeunload = null;
    this.subs.sink = this.activatedRoute.queryParamMap
      .subscribe(params => {
        this.cdServizio = <string>params.get('servizio');
        this.initIstanza(false);
      });
    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang
    });
    this.subs.sink = this.ratingForm.controls['valutazione'].valueChanges.subscribe({
      next: () =>{
        this.ratingService.selectedChoiceIndex = -1;
        this.ratingForm.patchValue({
          primaRisposta: null,
          secondaRisposta: null,
        })
      }
    });
    /*this.serviziToolbar = JSON.parse(localStorage.getItem('servicesStorage') ?? '{}');
    for(const servizio of this.serviziToolbar){
      if(servizio.nmServizio === 'Tributi'){
        this.ratingForm.patchValue({
          pnServizio: {
            id: servizio.id,
          }
        })
        break;
      }
    } */
  }

  //metodo che viene richiamato alla conferma di refreshare la pagina
  confirmRefresh(event: BeforeUnloadEvent): void {
    event.preventDefault();
    event.returnValue = 'Sei sicuro di voler aggiornare la pagina? Potresti perdere i dati inseriti.';
  }

  richiestaInizialeIstanza(): void {
    this.loading = true;
    this.dynamicFormRenderService.totalStepSubject.subscribe((total) => {
      this.totalSteps = total;
      console.error(this.totalSteps)
    });
    this.subs.sink = this.istanzaService.richiestaInizialeIstanza(this.inizializzaIstanza()).subscribe({
      next: (res) => {
        this.istanzaCorrente = res;
        this.jsonForm = JSON.parse(this.b64DecodeUnicode(<string>this.istanzaCorrente.istanza.servizio.jsonForm?.contenuto));
        localStorage.setItem('tributoItem', JSON.stringify(res))
        this.dynamicFormRenderService.clearFormControls();
        this.dynamicFormRenderService.importaFormDinamico(this.jsonForm);
        this.dynamicFormRenderService.mostraElemTab = true;
        if (res.integrazioni?.[0]?.documenti) {
          this.listaIstanzeAllegato = res.integrazioni[0].documenti;
          this.dynamicFormRenderService.isAllegati = true;
          this.dynamicFormRenderService.currentStepSubject.subscribe((step) => {
            this.currentStep = step;
            if(this.currentStep === this.totalSteps){
              this.anteprima = true;
              console.log("Ehiiii")
            }else{
              this.anteprima = false;
            }
          });
        }
        if (this.istanzaCorrente.jsonData?.contenuto) {
          this.dynamicFormRenderService.importaValori(JSON.parse(this.b64DecodeUnicode(this.istanzaCorrente.jsonData.contenuto)));
        } else {
          this.istanzaCorrente.jsonData = {contenuto: ""}
        }
      },
      error: (err) => {
        this.loading = false;
        this.mostraForm = false;
        let msg = ''
        if(err.error.messaggio){
          msg = err.error.messaggio;
        }else if(err.error.status === 401){
          msg = "Utente non autenticato o sessione scaduta";
        }else{
          msg = "Errore nel caricamento di una nuova istanza con stato: " + String(err.error.status);
        }
        this.alertService.creaAlert(msg, "danger", "sticky", 4000, true)
      },
      complete: () => {
        this.loading = false;
      }
    })
  }


  salvaBozza(): void {
    const str = JSON.stringify(this.dynamicFormRenderService.getJsonData())
    this.istanzaCorrente.istanza.stato.codice = "00";
    this.istanzaCorrente.istanza.stato.descrizione = "Bozza";
    this.loadingSave = true;
    if (this.istanzaCorrente.integrazioni?.[0].documenti) {
      this.istanzaCorrente.integrazioni[0].documenti = this.listaIstanzeAllegato
    }
    const blob = new Blob([str], {
      type: "application/json;charset=utf-8"
    });
    this.reader.readAsDataURL(blob);
    this.reader.onloadend = () => {
      if (this.istanzaCorrente.jsonData) {
        this.istanzaCorrente.jsonData.contenuto = String(this.reader.result).split(",")[1];
      }
      this.subs.sink = this.istanzaService.richiestaSalvaIstanza(this.istanzaCorrente).subscribe({
        next: (res) => {
          this.istanzaCorrente = res;
          if (this.istanzaCorrente.integrazioni?.[0].documenti) {
            this.listaIstanzeAllegato = this.istanzaCorrente.integrazioni[0].documenti;
          }
          this.alertService.creaAlert("Bozza salvata correttamente", "success", "sticky", 2000, true);
          this.loadingSave = false;
        },
        error: (err) => {
          this.loadingSave = false;
          this.dynamicFormRenderService.abilitaFormDinamico();
          this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 3000, true)
        }
      })
    }
  }

  goToPrenotaAppIst():void{
    if(this.istanzaCorrente.istanza.servizio.servizioAmm?.idUfficio){
      void this.router.navigateByUrl("/Appuntamenti/inserimento-dati-prenotazione?servizio=" + this.istanzaCorrente.istanza.servizio.servizioAmm.cdFunzione + "&ufficio=" + this.istanzaCorrente.istanza.servizio.servizioAmm.idUfficio)
    }
    else{
      void this.router.navigate(["/Appuntamenti/inserimento-dati-prenotazione"]);
    }
  }

  salvaIstanza(): void {
    this.loadingSave = true;
    let str: string;
    if(this.jsonData) {
      str = JSON.stringify(this.jsonData);
    }else{
      str = JSON.stringify(this.dynamicFormRenderService.getJsonData());
    }
    if (this.istanzaCorrente.integrazioni?.[0].documenti) {
      this.istanzaCorrente.integrazioni[0].documenti = this.listaIstanzeAllegato;
    }
    const blob = new Blob([str], {
      type: "application/json;charset=utf-8"
    });

    this.reader.readAsDataURL(blob);
    this.reader.onloadend = () => {
      if (this.istanzaCorrente.jsonData) {
        this.istanzaCorrente.jsonData.contenuto = String(this.reader.result).split(",")[1];
      }
      this.istanzaCorrente.istanza.stato.codice = "01";
      this.istanzaCorrente.istanza.stato.descrizione = "Protocollata";
      this.istanzaCorrente.istanza.stato.id = 11;
      this.subs.sink = this.istanzaService.richiestaSalvaIstanza(this.istanzaCorrente, this.salvaPre).subscribe({
        next: (res) => {
          this.istanzaCorrente = res;
          this.anteprima = false;
        },
        error: (err: HttpErrorResponse) => {
          this.anteprima = false;
          this.loadingSave = false;
          let msg = '';
          if (err.status === 409 || err.status === 400) {
            this.istanzaCorrente.istanza.stato.codice = "00";
            this.istanzaCorrente.istanza.stato.descrizione = "Bozza";
            this.dynamicFormRenderService.abilitaFormDinamico();
            msg = err.error.messaggio;
          }else if(err.error.status === 401){
            msg = "Utente non loggato o sessione scaduta";
          }
          this.alertService.creaAlert(msg, "danger", "sticky", 3000, true)
        },
        complete: () => {
          this.loadingSave = false;
          if (this.istanzaCorrente.integrazioni?.[0].pagamenti && this.istanzaCorrente.integrazioni[0].pagamenti.length > 0) {
            this.continuaPagamento();
          } else {
            if(this.istanzaCorrente?.istanza.id){
              this.goToRiepilogo(this.istanzaCorrente.istanza.id)
            }
          }
        }
      })
    }
  }

  stepPrecedente():void{
    this.dynamicFormRenderService.previousStep();
    this.anteprima = false;
  }

  stepSuccessivo():void{
    this.dynamicFormRenderService.nextStep();
  }

  checkValidity():boolean{
    this.isValid = this.dynamicFormRenderService.formValidity;
    const allCheck = this.checkAllegatiObbligatori();
    return !(this.isValid && allCheck);
  }

  sendForm():void{
    this.dynamicFormRenderService.sendJsonData();
  }

  anteprimaIstanza(): void {
    this.dynamicFormRenderService.checkJsonFormValidity();
    this.isValid = this.dynamicFormRenderService.formValidity;
    if (this.isValid) {
      if (this.checkAllegatiObbligatori()) {
        this.loading = true;
        const str = JSON.stringify(this.dynamicFormRenderService.getJsonData())
        if (this.istanzaCorrente.integrazioni?.[0].documenti) {
          this.istanzaCorrente.integrazioni[0].documenti = this.listaIstanzeAllegato;
        }
        const blob = new Blob([str], {
          type: "application/json;charset=utf-8"
        });

        this.reader.readAsDataURL(blob);
        this.reader.onloadend = () => {
          if (this.istanzaCorrente.jsonData) {
            this.istanzaCorrente.jsonData.contenuto = String(this.reader.result).split(",")[1];
          }
          this.istanzaService.validaIstanza(this.istanzaCorrente).subscribe({
            next: () => {
              this.loading = false;
              this.dynamicFormRenderService.disabilitaFormDinamico();
              this.anteprima = true;
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            },
            error: (err: HttpErrorResponse) => {
              this.loading = false;
              this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true)
            }
          })
        }
      } else {
        this.alertService.creaAlert("Inserisci tutti gli allegati prima di continuare", "danger", "sticky", 3000, true);
      }
    } else {
      this.alertService.creaAlert("Ci sono alcuni campi non validi", "danger", "sticky", 3000, true);
    }
  }

  initIstanza(aggiorna: boolean):void{
    this.loading = true;
    if(aggiorna){
      this.subs.sink = this.preferitiService.updatePreferiti().subscribe({
        next: () => {
          this.loading = false;
            this.alertService.creaAlert("Dati aggiornati correttamente","success", "sticky", 3000, true);
            this.richiestaInizialeIstanza();
        },
        error: (err) => {
          this.loading = false;
          if(err.error.messaggio) {
            this.alertService.creaAlert(err.error.messaggio, "warning", "sticky", 3000, true);
          }else{
            this.alertService.creaAlert("Preferiti non aggiornati", "warning", "sticky", 3000, true);
          }
          this.richiestaInizialeIstanza();
        }
      })
    }else{
      this.loading = false;
      this.richiestaInizialeIstanza();
    }
  }

  annullaInvio(): void {
    this.dynamicFormRenderService.abilitaFormDinamico();
    this.anteprima = false;
    this.dynamicFormRenderService.mostraElemTab = true;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  checkAllegatiObbligatori(): boolean {
    let checkedValue = true;
    if (this.listaIstanzeAllegato.length > 0) {
      this.listaIstanzeAllegato.forEach((all: IstanzaAllegato) => {
        if ((all.allegato.contenuto == null || all.allegato.contenuto.length < 1) && all.tipoIstanzaAllegato.flObbligatorio) {
          checkedValue = false;
        }
      })
    } else {
      checkedValue = true;
    }
    return checkedValue;
  }

  //metodo che decodifica una stringa in base64 in Unicode
  b64DecodeUnicode(str: string): string {
    return new TextDecoder().decode(this.base64ToArrayBuffer(str));
  }

  base64ToArrayBuffer(base64: any): any {

    const binaryString = window.atob(base64);

    const binaryLen = binaryString.length;

    const bytes = new Uint8Array(binaryLen);

    for (let i = 0; i < binaryLen; i++) {

      const ascii = binaryString.charCodeAt(i);

      bytes[i] = ascii;

    }

    return bytes;

  }

  //metodo che inizializza un'istanza (prima di fare la richiesta iniziale al be)
  inizializzaIstanza(): Istanza {
    if (this.userData.idLogin === undefined) {
      this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}')
    }
    return {
      descrizione: null,
      idDichiarante: <string>this.userData.idLogin,
      idRichiedente: <string>this.userData.idLogin,
      servizio: {
        id: null,
        cdServizio: this.cdServizio ? this.cdServizio : ''
      },
      stato: {
        codice: "00"
      },
      tipoEsito: {
        id: null
      }
    }
  }

  tornaIndietro(): void {
    if (window.history.state.previousRoute) {
      this.router.navigate([window.history.state.previousRoute])
    } else {
      this.router.navigate(['/home']);
    }
  }

  checkPreviousRouteCruscotto():boolean{
    return window.history.state.previousRoute === 'Servizi/IstanzeEmesse';
  }

  onFileDropped($event: any): void {
    Array.from(<FileList>$event).forEach(file => {
      if (this.files.indexOf(file) === -1) {
        this.erroreFileExist = false;
        this.files.push(file);
      } else {
        this.erroreFileExist = true;
      }
    })
  }

  continuaPagamento(): void {
    this._md_pagamento.nativeElement.click();
  }

  goToCruscotto(): void {
    this._md_pagamento_close.nativeElement.click();
    this.router.navigate(["Cruscotto/le-mie-attivita"], {state: {cambioVisuale: true}}).then();
  }

  goToIstanzeEmesse():void{
    void this.router.navigate(['Servizi/IstanzeEmesse']).then();
  }

  goToPagaSubito(): void {
    this._md_pagamento_close.nativeElement.click();
    if (this.istanzaCorrente.integrazioni?.[0].pagamenti) {
      this.messageService.sendPagamento({
        integrazione: this.istanzaCorrente.integrazioni[0],
        pagamento: this.istanzaCorrente.integrazioni[0].pagamenti[0],
        cdServizio: this.tributo.cdServizio ? this.tributo.cdServizio : '',
        descrizione: <string>this.istanzaCorrente.istanza.descrizione,
        flPagamento: this.istanzaCorrente.istanza.servizio.flPagamento ? this.istanzaCorrente.istanza.servizio.flPagamento : false
      })
    }
    this.router.navigate(['Servizi/PagamentoIstanza'], {state: {previousRoute: "Servizi/ListaPagamenti"}}).then();
  }

  rimuoviFile(file: File): void {
    this.files.splice(this.files.indexOf(file), 1)
  }

  inserisciFileAllegato(event: any, index: number): void {
    const file = event.target.files[0];
    this.aggiornaContenuto(file, index);
  }

  dropFileAllegato(event: any, index: number): void {
    const file = event[0];
    if (Object.values(FileSupportati).includes(file.type)) {
      this.aggiornaContenuto(file, index);
    } else {
      this.alertService.creaAlert("Inserire un file di tipo pdf, zip, png, jpeg o dockx", "danger", "sticky", 2000, true)
    }
  }

  aggiornaContenuto(file: File, index: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        this.listaIstanzeAllegato[index].allegato.contenuto = reader.result.toString().split(',')[1];
        this.listaIstanzeAllegato[index].allegato.titolo = file.name;
        this.listaIstanzeAllegato[index].allegato.size = file.size;
        if (this.width > 1000) {
          this._md_allegato.nativeElement.click();
        }
      }
    };
  }

  rimuoviContenuto(index: number): void {
    this.listaIstanzeAllegato[index].allegato.contenuto = '';
    this.listaIstanzeAllegato[index].allegato.titolo = `Allegato ${index + 1}`;
  }

  ngOnDestroy(): void {
    this.alertService.close();
    localStorage.removeItem('tributoItem');
    window.onbeforeunload = null;
  }

  formatDate(date: Date): string {
    return format(date, 'dd/MM/yyyy');
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number | undefined, decimals: number): string {
    if (bytes && bytes === 0) {
      return '0 Bytes';
    } else if (bytes) {
      const k = 1024;
      const dm = decimals <= 0 ? 0 : decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)).toString() + ' ' + sizes[i];
    } else {
      return '';
    }
  }

  public openFile(base64Data: string, fileName: string): void {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const fileExtension = fileName.split('.').pop()?.toLowerCase();

    let fileType: string | null = null;

    if (fileExtension!.toLowerCase() === 'pdf') {
      fileType = 'application/pdf';
    } else if (fileExtension!.toLowerCase() === 'jpg' || fileExtension === 'jpeg') {
      fileType = 'image/jpeg';
    } else if (fileExtension!.toLowerCase() === 'png') {
      fileType = 'image/png';
    } else if (fileExtension!.toLowerCase() === 'docx') {
      fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }

    if (fileType) {
      const fileBlob = new Blob([byteArray], {type: fileType});
      const fileUrl = URL.createObjectURL(fileBlob);
      window.open(fileUrl, '_blank');
    } else {
      this.alertService.creaAlert('Tipo di file non supportato.', "danger", "sticky", 5000, true);
    }
  }

  goToRiepilogo(id: string):void{
    void this.router.navigate(["/Servizi/conferma-richiesta/" + id])
  }

  goToServizi():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkServizi;
  }

  goToHome():void{
    this._md_pagamento_close.nativeElement.click();
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  goBack():void{
    window.onbeforeunload = null;
    if(this.anteprima){
      this.annullaInvio();
    }else{
      return void this.router.navigateByUrl("Servizi/consenso-privacy?servizio=" + <string>this.cdServizio).then();
    }
  }
}
